var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPenDarkDuskFaded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27062 12.607C4.74738 13.0805 5.52036 13.0805 5.99712 12.607L15.443 3.22453C16.1857 2.48688 16.1857 1.2909 15.443 0.553242C14.7004 -0.184415 13.4963 -0.184414 12.7537 0.553243L3.30776 9.93568C2.831 10.4092 2.831 11.177 3.30776 11.6506L4.27062 12.607ZM1.94434 12.0771C1.75123 11.8853 1.4251 11.9414 1.30821 12.1866L0.0846238 14.7529C-0.0743911 15.0865 -0.00517761 15.4833 0.257528 15.7442C0.530079 16.0149 0.948379 16.0777 1.28932 15.8991L3.78572 14.5914C4.01002 14.4739 4.05563 14.1742 3.87632 13.9961L1.94434 12.0771Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPenDarkDuskFaded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-pen-dark-dusk-faded.680ba78351e031bc94ad017e6d075f4b.svg";